export default __webpack_public_path__ + "static/media/like-g.e6184b36.svg";